import config from "../../config";
import {Customer, Session} from "./customer";
import {CustomerServiceError} from "./error";
import {getDeviceHeader} from "./device-header";


export class AcceptLoyaltyRequest {
  shareId:string;
  optInEmailAdvertisementConsent:boolean;
  optInEmailChannelNewsletter:boolean;
  optInEmailChannelLoyalty:boolean;
  optInEmailChannelWomensFashion:boolean;
  optInEmailChannelMensFashion:boolean;
}

export async function acceptLoyalty(req: AcceptLoyaltyRequest, session:Session): Promise<Customer> {
  const result = await fetch(`${config.customerServiceUrl}/customer/${session.customerId}/accept-loyalty`, {
    body: JSON.stringify(req),
    cache: 'no-cache',
    headers: {
      'content-type': 'application/json',
      'NY-SESSION-TOKEN': `${session.token}`,
      'NY-DEVICE-DATA': getDeviceHeader(),
    },
    method: 'POST',
  });

  const json = await result.json();
  if (json.error) {
    throw new Error("[customer-service] error while accept-loyalty: " + json.error)
  }

  if (!result.ok) {
    throw new CustomerServiceError(json);
  }

  return new Customer(json);
}
